import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PRIVACY_ANONYMOUS_USERS = defineFcm('privacy_anonymous_users')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				countries: {
					type: 'array',
					shape: { type: 'string' },
					optional: true,
				},
				users: {
					type: 'array',
					shape: { type: 'string' },
					optional: true,
				},
			},
		}),
	)
	.withDefault({
		countries: undefined,
		users: undefined,
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'APIs / security / safety',
		description: `Allows to specify a list of country codes (upper case) or user ids for which to enable user anonymization.

		Any user whose country (from their settings) is in the list of country codes or whose id is in the list of user ids will:
		- have their data anonymised (including their id) in all exposed APIs
		- appear as "Anonymous" to everyone except themselves, on all pages
		- have their /u/<id> page return a 404 except for themselves`,
		import: false,
		template: {
			countries: ['XX', 'YY'],
			users: ['123', '456'],
		},
	});
